<template>
  <div class="loading">
    <div class="loading__bar"></div>
  </div>
</template>

<script></script>

<style lang="scss">
.loading {
  position: fixed;
  top: 0;
  left: -25%;
  width: 25%;
  height: 4px;
  background-color: purple;
  z-index: 9999;
  animation: loading 1.5s ease-in-out infinite;

  @keyframes loading {
    0% {
      left: -25%;
    }
    100% {
      left: 100%;
    }
  }
}
</style>
